export default __webpack_public_path__ + "static/media/user-placeholder.33e7df09.png";